import { Logger } from '../../generic/utils';
import { wrapperIdentifier } from './common';
import { useEffect } from 'react';
import { wrapperBuilder } from './build';

const console = new Logger(wrapperIdentifier);

if (console) {
  //Just for usage
}

wrapperBuilder.getCustomLogicRegisterInstance().setLogic(
  ({
    functions: { loadProductDefinitions },
    variablesHandler: {
      variables: { productDefinitions },
      variablesSetter,
    },
    bindedContexts: { user },
  }) => {
    const userId = user && (user._id || user.id);

    useEffect(() => {
      if (userId) {
        console.log('ºº Loading productDefinitions');
        loadProductDefinitions();
      } else if (!userId) {
        if (productDefinitions) {
          variablesSetter('productDefinitions')(undefined);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);
  }
);
